import React from 'react';
import { Pagination as BootstrapPagination } from 'react-bootstrap';

const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const maxPagesToShow = 5;
  let startPage, endPage;

  if (totalPages <= maxPagesToShow) {
    // Total pages less than or equal to max pages we want to show
    startPage = 1;
    endPage = totalPages;
  } else {
    // More than max pages we want to show, calculate start and end pages
    const maxPagesBeforeCurrentPage = Math.floor(maxPagesToShow / 2);
    const maxPagesAfterCurrentPage = Math.ceil(maxPagesToShow / 2) - 1;
    if (currentPage <= maxPagesBeforeCurrentPage) {
      // Near the start
      startPage = 1;
      endPage = maxPagesToShow;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      // Near the end
      startPage = totalPages - maxPagesToShow + 1;
      endPage = totalPages;
    } else {
      // Somewhere in the middle
      startPage = currentPage - maxPagesBeforeCurrentPage;
      endPage = currentPage + maxPagesAfterCurrentPage;
    }
  }

  const handleClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  return (
    <BootstrapPagination>
      <BootstrapPagination.First onClick={() => handleClick(1)} disabled={currentPage === 1} />
      <BootstrapPagination.Prev onClick={() => handleClick(currentPage - 1)} disabled={currentPage === 1} />
      {Array.from({ length: endPage - startPage + 1 }, (_, index) => (
        <BootstrapPagination.Item key={startPage + index} active={startPage + index === currentPage} onClick={() => handleClick(startPage + index)}>
          {startPage + index}
        </BootstrapPagination.Item>
      ))}
      <BootstrapPagination.Next onClick={() => handleClick(currentPage + 1)} disabled={currentPage === totalPages} />
      <BootstrapPagination.Last onClick={() => handleClick(totalPages)} disabled={currentPage === totalPages} />
    </BootstrapPagination>
  );
};

export default Pagination;
